import { Divider } from '@faceup/ui-base'
import { defaultLogoSize } from '@faceup/utils'
import { useContext } from 'react'
import { type FragmentType, getFragmentData, graphql } from '../../__generated__'
import { LayoutContext } from '../../Contexts/LayoutContext'
import { useInstitution } from '../../hooks/useInstitution'
import { Header } from '../Header/Header'
import { SimpleHeaderContent } from '../Header/SimpleHeaderContent'
import InstitutionLogo from '../InstitutionLogo'

export const fragments = {
  SurveyHeader_survey: graphql(`
    fragment SurveyHeader_survey on PublicSurvey {
      logoUrl
      defaultLanguage
      institution {
        config {
          institutionName
        }
        partner {
          name
          config {
            rectangularLogoUrl
          }
        }
      }
    }
  `),
}

type SurveyHeaderProps = {
  survey: FragmentType<typeof fragments.SurveyHeader_survey>
  isHiddenBackButton?: boolean
}

export const SurveyHeader = ({ survey: _survey, isHiddenBackButton }: SurveyHeaderProps) => {
  const survey = getFragmentData(fragments.SurveyHeader_survey, _survey)
  const { client } = useContext(LayoutContext)
  const institutionContext = useInstitution()
  const isApp = client === 'app'
  const homepageLinkCallback = institutionContext?.homepage ?? (routes => routes.home())

  return (
    <Header>
      <SimpleHeaderContent
        isApp={isApp}
        isHiddenBackButton={isHiddenBackButton ?? false}
        homepageLinkCallback={homepageLinkCallback}
        logoSlot={
          <div className='flex gap-4 nowrap max-h-full items-center overflow-hidden min-w-0'>
            <InstitutionLogo
              name={survey.institution.config?.institutionName ?? ''}
              logoUrl={survey.logoUrl}
              logoSize={defaultLogoSize}
            />
            {survey.institution.partner?.config?.rectangularLogoUrl && (
              <>
                <Divider type='vertical' />
                <InstitutionLogo
                  name={survey.institution.partner.name}
                  logoUrl={survey.institution.partner.config.rectangularLogoUrl}
                  logoSize={defaultLogoSize}
                />
              </>
            )}
          </div>
        }
        languages={null}
        defaultLanguage={survey.defaultLanguage}
      />
    </Header>
  )
}
